import "./index.css"

import Search from "../../../components/custom/input/search"
import Drawer from "../../../components/holders/drawer"
import { useEffect, useState } from "react"
import Icon from "../../../components/custom/icon"

const ListView = ({
    getDataKey,
    sortConfig,
    filterConfig,
    list,
    map,
    sortPrompt,
    filterPrompt,
    searchPrompt,
    emptyMessage,
    expandPrompt,
    defaultSortIndex
}) => {

    const [expanded, setExpanded] = useState(false)
    const [showSort, setShowSort] = useState(false)
    const [showFilter, setShowFilter] = useState(false)
    const [processedList, setProcessedList] = useState(list)
    const [filterKey, setFilterKey] = useState('')
    const [sortConfigIndex, setSortConfigIndex] = useState(defaultSortIndex ?? null)
    const [filterConfigIndex, setFilterConfigIndex] = useState(null)

    const getDefaultDataKey = key => isNaN(key) ? 'name' : 'phone'

    getDataKey = getDataKey || getDefaultDataKey
    const filterKeyExp = filterKey.toLowerCase().replace(/\s+/g, '')
    const dataKey = getDataKey(filterKeyExp)

    useEffect(() => {
        let filteredList = filterKey
            ? list.filter(a => a[dataKey].toLowerCase().replace(/\s+/g, '').includes(filterKeyExp))
            : list.map(a => a)

        if (sortConfig && sortConfigIndex !== null) {
            const sortCfg = sortConfig[sortConfigIndex]
            filteredList.sort((a, b) => {
                let aa = a[sortCfg.key] === null || a[sortCfg.key] === undefined ? '' : a[sortCfg.key]
                let bb = b[sortCfg.key] === null || b[sortCfg.key] === undefined ? '' : b[sortCfg.key]
                if (aa > bb) {
                    return sortCfg.asc ? 1 : -1
                } else if (aa < bb) {
                    return sortCfg.asc ? -1 : 1
                } else {
                    return 0
                }
            })
        }

        if (filterConfig && filterConfigIndex !== null) {
            const filterCfg = filterConfig[filterConfigIndex]
            if (typeof filterCfg.match === 'function') {
                filteredList = filteredList.filter(item => filterCfg.match(item))
            } else {
                filteredList = filteredList.filter(item => {
                    const val = item[filterCfg.key]
                    return val === filterCfg.value
                })
            }
        }

        setProcessedList(filteredList)
    }, [sortConfigIndex, filterConfigIndex, filterKey, list, sortConfig, filterConfig])

    const handleShowSort = () => {
        setShowSort(true)
    }

    const handleHideSort = () => {
        setShowSort(false)
    }

    const handleSort = i => {
        setShowSort(false)
        setSortConfigIndex(i)
    }

    const handleShowFilter = () => {
        setShowFilter(true)
    }

    const handleHideFilter = () => {
        setShowFilter(false)
    }

    const handleFilter = i => {
        setShowFilter(false)
        setFilterConfigIndex(i)
    }

    return (
        <div className="lv-tab-main">

            {showSort && (
                <Drawer title={sortPrompt || "Choose sort order"} onClose={handleHideSort}>
                    <div>
                        {sortConfig.map((cfg, i) => (
                            <div className="lv-sort-main" onClick={() => handleSort(i)}>
                                <Icon name="tick" color={sortConfigIndex == i ? "#555" : "#fff"} className="lv-sort-tick" />
                                <div key={cfg.name}>{cfg.name}</div>
                            </div>
                        ))}
                    </div>
                </Drawer>
            )}

            {showFilter && filterConfig && (
                <Drawer title={filterPrompt || "Choose filter order"} onClose={handleHideFilter}>
                    <div>
                        {filterConfig.map((cfg, i) => (
                            <div className="lv-filter-main" onClick={() => handleFilter(i)}>
                                <Icon name="tick" color={filterConfigIndex == i ? "#555" : "#fff"} className="lv-filter-tick" />
                                <div key={cfg.name}>{cfg.name}</div>
                            </div>
                        ))}
                    </div>
                </Drawer>
            )}

            <div className="lv-search-main">
                <Search width="70vw" delay={100} onSearch={setFilterKey} placeholder={searchPrompt || "Type to search..."} />
                {sortConfig && sortConfig.length > 0 && (
                    <Icon className="lv-sort-icon" name="sort" color="#888" onClick={handleShowSort} />
                )}
                {filterConfig && filterConfig.length > 0 && (
                    <Icon className="lv-filter-icon" name="filter" color="#888" onClick={handleShowFilter} />
                )}
            </div>

            <div className="lv-res-head">
                <div className="lv-res-count">{`Showing ${processedList.length} result${processedList.length !== 1 ? 's' : ''}`.trim()}</div>

                {sortConfig && sortConfigIndex !== null ? <div className="lv-res-count">
                    <span>{`Sort: ${sortConfig[sortConfigIndex].name}`}</span>
                    <div className="lv-sort-clear" onClick={() => { setSortConfigIndex(defaultSortIndex ?? null) }}>Clear</div>
                </div> : null}
                
                {filterConfig && filterConfigIndex !== null ? <div className="lv-res-count">
                    <span>{`Filter: ${filterConfig[filterConfigIndex].name}`}</span>
                    <div className="lv-filter-clear" onClick={() => { setFilterConfigIndex(null) }}>Clear</div>
                </div> : null}

            </div>

            {processedList.length ?
                <div style={{ boxSizing: "border-box" }}>
                    {processedList.slice(0, expanded ? processedList.length : 20).map(map)}
                </div> :
                <div className="lv-no">{emptyMessage || "No results found"}</div>
            }

            {!expanded && processedList.length > 20 && (
                <div className="lv-more" onClick={() => setExpanded(true)}>
                    <div>{expandPrompt || "Show all"}</div>
                    <Icon name='arrow-drop-down' color='#eee' />
                </div>
            )}
        </div>
    )
}

export default ListView